import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL
});

export const ibge = axios.create({
  baseURL: process.env.REACT_APP_IBGE_URL
});

export const file_api = axios.create({
  baseURL: process.env.REACT_APP_FILE_API_URL
});

